import React, { SVGProps } from 'react'
const SvgReceiptAttached = (
  props: SVGProps<SVGSVGElement>,
): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    aria-hidden="true"
    {...props}
  >
    <path
      fill={props.fill || '#1B2C4F'}
      fillRule="evenodd"
      d="M5.963 3.938a.713.713 0 0 0-.713.713v15.837l2.92-2.695a.803.803 0 0 1 1.017-.06l2.825 2.055 2.567-2.053a.803.803 0 0 1 .923-.057l2.998 1.844V4.652a.713.713 0 0 0-.713-.714H5.963Zm-1.713.713c0-.946.767-1.713 1.713-1.713h11.824c.946 0 1.713.767 1.713 1.713v15.224a.803.803 0 0 1-1.224.684l-3.18-1.957-2.576 2.061a.803.803 0 0 1-.975.023L8.73 18.637l-3.131 2.89a.803.803 0 0 1-1.348-.59V4.651Z"
      clipRule="evenodd"
    />
    <path
      fill={props.fill || '#1B2C4F'}
      fillRule="evenodd"
      d="M7.888 11.643a.5.5 0 0 1 .5-.5h4.103a.5.5 0 1 1 0 1H8.388a.5.5 0 0 1-.5-.5ZM7.888 7.677a.5.5 0 0 1 .5-.5h6.154a.5.5 0 1 1 0 1H8.388a.5.5 0 0 1-.5-.5Z"
      clipRule="evenodd"
    />
  </svg>
)
export default SvgReceiptAttached
